class ZoomButtons {
	container
	padElement
	region
	eventRepeatTimeout
	zoomInButton
	zoomOutButton

	mouseDown = false

	constructor(container, canvas) {
		this.container = container
		this.padElement = document.createElement('div')
		this.padElement.classList.add('zoom-plus-pad')
		this.region = document.createElement('div')
		this.region.classList.add('region')

		this.zoomInButton = document.createElement('button')
		this.zoomInButton.innerHTML = `<i class="fa fa-plus"></i>`
		this.zoomInButton.classList.add('mobile-ui-button')
		this.zoomInButton.classList.add('zoom-in')

		this.zoomOutButton = document.createElement('button')
		this.zoomOutButton.innerHTML = `<i class="fa fa-minus"></i>`
		this.zoomOutButton.classList.add('mobile-ui-button')
		this.zoomOutButton.classList.add('zoom-out')

		this.padElement.append(this.zoomInButton)
		this.padElement.append(this.zoomOutButton)
		this.container.append(this.padElement)

		this.setupPositions()

		window.addEventListener("resize", (e) => {
			this.setupPositions()
		})


		let touchEnd = () => {
			this.mouseDown = false
		}

		// Mouse events:
		this.zoomInButton.addEventListener('mousedown', (event) => {
			this.mouseDown = true
			this.sendEvent("wheel", {deltaY: -100})
		})
		this.zoomInButton.addEventListener('touchstart', (event) => {
			this.mouseDown = true
			this.sendEvent("wheel", {deltaY: -100})
		})
		this.zoomInButton.addEventListener('mouseup', touchEnd)
		this.zoomInButton.addEventListener('touchend', touchEnd)
		this.zoomInButton.addEventListener('touchcancel', touchEnd)

		// Mouse events:
		this.zoomOutButton.addEventListener('mousedown', (event) => {
			this.mouseDown = true
			this.sendEvent("wheel", {deltaY: 100})
		})
		this.zoomOutButton.addEventListener('touchstart', (event) => {
			this.mouseDown = true
			this.sendEvent("wheel", {deltaY: 100})
		})
		this.zoomOutButton.addEventListener('mouseup', touchEnd)
		this.zoomOutButton.addEventListener('touchend', touchEnd)
		this.zoomOutButton.addEventListener('touchcancel', touchEnd)
	}

	setupPositions() {
		// Aligning pad position:
		this.padElement.style.top = this.container.offsetHeight + this.container.getBoundingClientRect().top
			- this.region.offsetHeight - 40 + 'px'
		this.padElement.style.left = '100px'
	}

	sendEvent(event, eventData = {}) {
		if (this.eventRepeatTimeout) {
			clearTimeout(this.eventRepeatTimeout)
		}

		if (!this.mouseDown) {
			return
		}

		this.eventRepeatTimeout = setTimeout(() => {
			this.sendEvent(event,eventData)
		}, 20)

		let moveEvent = new CustomEvent(event, {
			bubbles: false,
			detail: eventData
		})
		this.padElement.dispatchEvent(moveEvent)
	}
}


export default ZoomButtons
